export enum EU_TARIFF_TYPES {
  STANDARD = 'STANDARD',
  INSTALLMENT = 'INSTALLMENT',
  SUBSIDY = 'SUBSIDY',
  PREFERENTIAL = 'PREFERENTIAL'
}

export const EU_TARIFF_TYPE_TEXTS = {
  [EU_TARIFF_TYPES.STANDARD]: 'Стандарт',
  [EU_TARIFF_TYPES.INSTALLMENT]: 'Рассрочка',
  [EU_TARIFF_TYPES.SUBSIDY]: 'Субсидия',
  [EU_TARIFF_TYPES.PREFERENTIAL]: 'Льготное кредитование'
};
